// The ported Prestige 6 product form adds to cart on its own and announces it with `product:added`.
// Prestige 11's cart drawer and counters only react to `cart:change`, so re-emit it in that shape.
document.addEventListener('product:added', async () => {
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  const sections = [];
  document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
    bubbles: true,
    detail: { sections },
  }));

  const [cart, rendered] = await Promise.all([
    fetch(`${root}cart.js`).then((response) => response.json()),
    sections.length
      ? fetch(`${root}?sections=${encodeURIComponent(sections.join(','))}`).then((response) => response.json())
      : Promise.resolve({}),
  ]);

  cart.sections = rendered;
  document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
    bubbles: true,
    detail: { baseEvent: 'variant:add', cart },
  }));
});
